import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../images/logo.svg";
import "./Navbar.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigate = useNavigate();

  const navigateToService = (section) => {
    navigate("/our-services", {
      state: {
        activeSection: section,
      },
    });

    setDropdownOpen(false);
    setMenuActive(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMenu = () => {
    setMenuActive(false);
    setDropdownOpen(false);
  };

  return (
    <header className={`navbar ${isScrolled ? "black" : ""}`}>
      {/* Logo */}
      <div className="logo">
        <img src={Logo} alt="logo" />
      </div>

      {/* Mobile Menu Icon */}
      <div className="menu">
        <h4 onClick={() => setMenuActive(!menuActive)}>☰</h4>
      </div>

      {/* Navigation */}
      <nav className={`nav-links ${menuActive ? "active" : ""}`}>
        <NavLink to="/" end onClick={closeMenu}>
          Home
        </NavLink>
        
        <NavLink to="/about" onClick={closeMenu}>
          About Us
        </NavLink>
        
        <div className="dropdown">
          <span className="dropdown-title">
            <a onClick={() => navigateToService("cqc-Ourservices")}>
              Our Services
            </a>
          </span>

          <ul className="dropdown-menu">
            <li onClick={() => navigateToService("cqc-services")}>
              CQC Services
            </li>

            <li onClick={() => navigateToService("care-home-sales")}>
              Care Home Sales
            </li>

            <li onClick={() => navigateToService("accounting")}>
              Accounting
            </li>

            <li onClick={() => navigateToService("software")}>
              Software
            </li>

            <li onClick={() => navigateToService("operational-management")}>
              Operational Management
            </li>
          </ul>
        </div>

        <NavLink to="/insights" onClick={closeMenu}>
          Insights
        </NavLink>

        <NavLink to="/faqs" onClick={closeMenu}>
          FAQs
        </NavLink>
      </nav>

      {/* CTA Button */}
      <button className="Navbar-btn">
        <a link href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U"><span>Discover More</span></a>
       
      </button>
    </header>
  );
};

export default Header;